import { observable } from "mobx";
import { Type } from "class-transformer";
import DateRangeRequest from "./dateRangeRequest";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RoadTollPaymentStatisticsReportRequest {
  @observable
  @Type(() => DateRangeRequest)
  reportDateRange!: DateRangeRequest;

  @observable
  gatewayId?: string;
}
